const center = {
  dengue: [
    [
      [39.7837304, -100.44588250000001],
      [16.002065925, 79.0619981070291],
      [17.5148382, 118.4470116],
      [50.6402809, 4.666714499999998],
      [-33.8548157, 151.2164539],
      [31.110630299999997, 73.65035361428572],
      [21.2434615875, 76.0808800125],
      [2.392375900000001, 112.84719390000001]
    ],
    [3, 18, 2, 1, 1, 7, 8, 1]
  ],
  ebola: [
    [
      [7.076979771999996, 5.552882267999999],
      [31.419784456871902, -82.53906617021309],
      [-31.269062787500005, 155.938070431023],
      [52.156788430769225, 2.255000162971969],
      [-27.16738337959184, -70.13419696734692],
      [25.173975499999997, 87.312876],
      [-8.564791050000002, 32.080109329449954],
      [36.75922954, -113.41414744000001]
    ],
    [25, 6, 4, 13, 3, 2, 7, 5]
  ],
  flu: [
    [
      [52.11937053263889, 0.44604536467335976],
      [43.30560543382353, -118.50891406589727],
      [11.100515435294117, 110.36298275666837],
      [-20.745055809523812, 25.024179189035593],
      [39.55986698966616, -84.08295528595698],
      [-32.90488980999999, 140.8214744234223],
      [29.6818796525, 57.70507261587178],
      [-7.534534999999998, -61.52865343333333]
    ],
    [144, 34, 17, 21, 74, 10, 20, 6]
  ],
  lyphoma: [[], []],
  malaria: [
    [
      [7.462253539999999, 6.364854539999996],
      [42.57970653333333, -120.86503090000001],
      [22.882800366666665, 94.65292406666666],
      [53.579052607142856, 4.893704788155521],
      [37.581434875, -79.37745151901825],
      [21.3250785, -157.846644178573],
      [-2.4967506333333347, 35.06214753333334],
      [35.492584575, -99.1088201567678]
    ],
    [10, 3, 3, 7, 6, 1, 3, 2]
  ]
};

export default center;
